// src/theme.ts
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#25d366',
    },
    secondary: {
      main: '#ffffff',
    },
    background: {
      paper: '#ffffff',
      default: '#f5f5f5',
    },
    divider: '#e0e0e0',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ':root': {
          '--mui-primary-main': '#25d366',
          '--mui-background-paper': '#ffffff',
          '--mui-divider': '#e0e0e0',
        },
      },
    },
  },
});

export default theme;

